import { render, staticRenderFns } from "./MXSortTable.vue?vue&type=template&id=5e865f69&scoped=true"
import script from "./MXSortTable.vue?vue&type=script&lang=js"
export * from "./MXSortTable.vue?vue&type=script&lang=js"
import "./MXSortTable.vue?vue&type=style&index=0&id=5e865f69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e865f69",
  null
  
)

export default component.exports